module.exports = __webpack_public_path__ + "static/media/rksv_description.6393db29.png";